var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep7To6Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3536 0.646446C46.1583 0.451183 45.8417 0.451183 45.6464 0.646446L42.4645 3.82843C42.2692 4.02369 42.2692 4.34027 42.4645 4.53553C42.6597 4.7308 42.9763 4.7308 43.1716 4.53553L46 1.70711L48.8284 4.53553C49.0237 4.7308 49.3403 4.7308 49.5355 4.53553C49.7308 4.34027 49.7308 4.02369 49.5355 3.82843L46.3536 0.646446ZM-4.07726e-08 46.5L26 46.4999L26 45.4999L4.07726e-08 45.5L-4.07726e-08 46.5ZM46.5 26L46.5 1L45.5 1L45.5 26L46.5 26ZM26 46.4999C37.3219 46.4999 46.5 37.3218 46.5 26L45.5 26C45.5 36.7695 36.7696 45.4999 26 45.4999L26 46.4999Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep7To6Mobile);
export default __webpack_public_path__ + "static/media/step_7_to_6_mobile.3c2e62d1d5de000bc1d822eba3700318.svg";
export { ForwardRef as ReactComponent };